import { render } from "./AboutMeComponent.vue?vue&type=template&id=60c8cc8a&scoped=true&ts=true"
import script from "./AboutMeComponent.vue?vue&type=script&lang=ts"
export * from "./AboutMeComponent.vue?vue&type=script&lang=ts"

import "./AboutMeComponent.vue?vue&type=style&index=0&id=60c8cc8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c8cc8a"]])

export default __exports__